<div class="edit-page-root-container customization-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{getTitle()}}
            </div>
            <div class="action-btn-container">
                    @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                    }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" *ngIf="editForm" [formGroup]="editForm" (keydown.enter)="onEnter($event)">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code"
                                        [readonly]="customizationInfo.id!==undefined && customizationInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Customization code
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Customization name
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Display Name</mat-label>
                                    <input matInput formControlName="display_name">
                                    <!-- <mat-error *ngIf="editForm.controls['display_name'].hasError('required')">Reasons code
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['display_name'].hasError('maxlength')">Maximum length is
                                        10.</mat-error> -->
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Display Order</mat-label>
                                    <input matInput formControlName="display_order" type="number">
                                    <!-- <mat-error *ngIf="editForm.controls['name'].hasError('required')">Reasons name
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error> -->
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <!-- <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length
                                is
                                200.</mat-error> -->
                        </mat-form-field>

                        <div class="input-group">
                            <div class="color-container">
                                <mat-form-field class="color-container-div">
                                    <mat-label>Option For</mat-label>
                                    <mat-select formControlName="option_for">
                                        <mat-option *ngFor="let opfr of optionForList" [value]="opfr.name">
                                            {{ opfr.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="color-container-div">
                                    <mat-label>Background Color</mat-label>
                                    <input matInput formControlName="bg_color" type="color">
                                </mat-form-field>
                                <mat-form-field class="color-container-div">
                                    <mat-label>Foreground color</mat-label>
                                    <input matInput type="color" formControlName="fg_color">
                                </mat-form-field>
                            </div>
                        </div>
                        <div>
                            <div class="table-responsive-wrapper">
                                <table id="attributes" style="margin-top: 5px;">
                                    <thead>
                                        <tr>
                                            <th class="table-column-medium">Name</th>
                                            <th class="table-column-medium">Online Name</th>
                                            <th class="table-column-medium">Name to Print</th>
                                            <th class="table-column-medium">Sale Item</th>
                                            <th class="table-column-small">
                                                QTY</th>
                                            <th class="table-column-small">
                                                PRICE</th>
                                            <th class="table-column-small">Default</th>
                                            <th class="table-column-small">Disp.Ord</th>
                                            <th><button mat-raised-button color="primary" (click)="addOption()">
                                                    Add</button></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="customizationOptionValues">
                                        <tr *ngFor="let group of options.controls; let i = index" [formGroupName]="i">
                                            <td>
                                                <mat-form-field style="width:200px;">
                                                    <input matInput placeholder="Name" formControlName="name">
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field style="width:200px;">
                                                    <input matInput placeholder="Online Name"
                                                        formControlName="online_name">
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field style="width:200px;">
                                                    <input matInput placeholder="Name To Print"
                                                        formControlName="name_to_print">
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field style="width:200px;">
                                                    <input matInput type="text" [formControlName]="'sale_item'"
                                                        placeholder="Select Sale Item"
                                                        [matAutocomplete]="saleItemAutoComplete"
                                                        (input)="filterSaleItems(i)" (focus)="filterSaleItems(i)">
                                                    <button *ngIf="group.get('sale_item')?.value"
                                                        (click)="clearSaleItem(i)" matSuffix mat-icon-button
                                                        aria-label="Clear">
                                                        <mat-icon
                                                            style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                                                    </button>
                                                    <mat-autocomplete [displayWith]="displaySaleItemName.bind(this)"
                                                        #saleItemAutoComplete="matAutocomplete"
                                                        (optionSelected)="onSaleItemSelected($event, i)">
                                                        <mat-option *ngFor="let item of filteredSaleItemsArray[i]"
                                                            [value]="item">
                                                            <span>{{item.name}}</span>
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                    <mat-error
                                                        *ngIf="group.get('sale_item')?.hasError('invalidSaleItem')">
                                                        Invalid sale item selected.
                                                    </mat-error>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field style="width: 80px;">
                                                    <input class="right-align" matInput type="number"
                                                        formControlName="quantity">
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field style="width: 100px;">
                                                    <input class="right-align" matInput formControlName="price"
                                                        aria-disabled="true">
                                                </mat-form-field>
                                            </td>
                                            <td class="center-cell" style="height: 66px;
    padding-bottom: 21px;">
                                                <mat-radio-group [value]="getDefaultIndex()"
                                                    (change)="setDefault($event.value)">
                                                    <mat-radio-button [value]="i"></mat-radio-button>
                                                </mat-radio-group>
                                            </td>
                                            <td>
                                                <mat-form-field style="width: 80px;">
                                                    <input class="right-align" matInput type="number"
                                                        formControlName="display_order">
                                                </mat-form-field>
                                            </td>
                                            <td style="text-align: center;">
                                                <button mat-icon-button aria-label="Delete" (click)="removeOption(i)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>